<div class="billing-disclaimers" *ngIf="showAny && !isAcmic">
  <div *ngIf="showOutstandingBalance" class="add-policy-row disclaimer-text">
    *Amounts displayed may not reflect all recent policy changes or payments.
  </div>
  <div *ngIf="showPif" class="add-policy-row disclaimer-text">
    **Your paid in full amount may not reflect recent premium changes.
  </div>
  <div *ngIf="showMinAmtDue" class="add-policy-row disclaimer-text">
    ***May not include all fees.
  </div>
</div>

<div class="billing-disclaimers" *ngIf="isAcmic">
  <div class="add-policy-row disclaimer-text">
    *Amounts displayed may not reflect all recent policy changes or payments.
  </div>
</div>
